import { setThemeColor } from '@/utils/utils'

/**
 * 自定义钩子，用于设置和重置浏览器的主题颜色。
 *
 * @param {Object} options - 配置选项
 * @param {string} options.color - 要设置的主题颜色
 * @param {boolean} [options.immediate=false] - 是否在挂载前立即设置颜色
 *
 * @returns {Object} 返回一个对象，包含设置和重置主题颜色的方法
 * @returns {Function} return.set - 设置主题颜色的方法
 * @returns {Function} return.reset - 重置为原始主题颜色的方法
 *
 * 当组件挂载时，如果 immediate 为 true 且提供了颜色，则会设置主题颜色。
 * 当组件卸载时，会重置为原始的主题颜色。
 */
export const useThemeColor = ({
  color,
  immediate = false
} = {}) => {
  let originalColor = null

  onBeforeMount(() => {
    originalColor = document.head.querySelector('meta[name="theme-color"]')?.content
    if (immediate && color) {
      set(color)
    }
  })

  const set = (val) => {
    setThemeColor(val ?? color)
  }

  const reset = () => {
    if (originalColor) {
      document.head.querySelector('meta[name="theme-color"]').setAttribute('content', originalColor)
    }
  }

  onBeforeUnmount(() => {
    reset()
  })

  return {
    set,
    reset
  }
}
